import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "../lib/transitions"

export default class extends Controller {
  static targets = [ "panel" ]

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  close() {
    leave(this.panelTarget)
  }

  open() {
    enter(this.panelTarget)
  }
}
